import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import TcButton from '../TcButton';
import TcPaper from '../TcPaper';
import LoadingScreen from '../shared/LoadingScreen';
import { useDeviceDetection } from '../../hooks/useDeviceDetection';
import { useSimpleImagePreloader } from '../../hooks/useImagePreloader';
import TcScanQrCodeBar from '../TcScanQrCodeBar';
import PeranakanDesignTiles from './PeranakanDesignTiles/PeranakanDesignTiles';

import imagePeranakanTilesBg from '../../assets/images/exhibit/peranakan/tiles/img_peranakan_tiles_bg.jpg';
import imagePeranakanTile01 from '../../assets/images/exhibit/peranakan/tiles/images_peranakan-design_tile_01.png';
import imagePeranakanTile02 from '../../assets/images/exhibit/peranakan/tiles/images_peranakan-design_tile_02.png';
import imagePeranakanTile03 from '../../assets/images/exhibit/peranakan/tiles/images_peranakan-design_tile_03.png';
import imagePeranakanTile04 from '../../assets/images/exhibit/peranakan/tiles/images_peranakan-design_tile_04.png'; 


export default function PeranakanPatterns() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    // Device detection
    const { orientation } = useDeviceDetection();
    const isLandscape = orientation === 'landscape';
    
    // Debug QR scan parameters
    useEffect(() => {
        const fromQrScan = searchParams.get('fromQrScan');
        const qrTimestamp = searchParams.get('qrTimestamp');
        
        if (fromQrScan === 'true') {
            console.log('🎯 PeranakanPatterns: QR scan parameters detected:', {
                fromQrScan,
                qrTimestamp,
                searchParams: searchParams.toString()
            });
        } else {
            console.log('🔍 PeranakanPatterns: No QR scan parameters found in URL');
        }
    }, [searchParams]);

    // Preload all images when component mounts
    const allImages = [
        imagePeranakanTilesBg,
        imagePeranakanTile01,
        imagePeranakanTile02,
        imagePeranakanTile03,
        imagePeranakanTile04
    ];

    const { isLoading, isComplete } = useSimpleImagePreloader(allImages);

    const handleDiscoverCulture = () => {
        // Navigate to PeranakanCulture
        navigate('/exhibit/peranakan-culture');
    };

    const handleReturnToIntro = () => {
        // Navigate to PeranakanDesign
        navigate('/exhibit/peranakan-design');
    };

    // Show loading state while images are being cached
    if (isLoading) {
        return <LoadingScreen message="Loading images..." />;
    }

    // Pattern selection screen
    return (
        <div className={`
            main-content-wrapper bg-black 
            ${isLandscape ? '!pt-8' : '!pt-[112px]'} 
            unselectable 
            has-transition 
        `}>
            <TcPaper classNameStyle="mt-4">
                <h1>{t('exhibits.peranakanDesign.patternTitle')}</h1>
            </TcPaper>

            <TcPaper classNameStyle="general-content">
                <p
                    dangerouslySetInnerHTML={{ __html: t('exhibits.peranakanDesign.patternDescription') }}
                />
            </TcPaper>

            <PeranakanDesignTiles allImages={allImages} />

            <div className="button-wrapper flex flex-col gap-4 px-6 !max-w-lg has-transition">
                <TcButton
                    handleClick={handleDiscoverCulture}
                    primary
                >
                    {t('exhibits.peranakanDesign.discoverTheCulture')}
                </TcButton>
                <TcButton
                    handleClick={handleReturnToIntro}
                    primary
                >
                    {t('exhibits.peranakanDesign.returnToIntro')}
                </TcButton>
            </div>

            <TcScanQrCodeBar classNameStyle="fixed bottom-0 left-0 right-0 z-[20]" />
        </div>
    );
} 